import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import baseUrl from "../../utilities/baseUrl";

const useAvaexpress = () => {
  const url = baseUrl + "/internalpost/v1/avaexpressRate";
  const token = localStorage.getItem("token");

  const { mutateAsync } = useMutation({
    mutationKey: ["avaexpress-rate"],
    mutationFn: body =>
      axios
        .post(
          url,
          {
            ...body,
            collectingType: 1,
            internalSectionId: 1,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: "Bearer " + token,
            },
            timeout: 18000,
          }
        )
        .then(res => ({
          chaparData: res.data.data,
          Data: body.postItem,
        }))
        .catch(() => ({
          Data: body.postItem,
          chaparData: { quote: 0 },
        })),
  });

  return { avaexpressRate: mutateAsync };
};

export default useAvaexpress;
